import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    q: "Two weeks before our auction date, Clear Path Home Relief Services negotiated a loan modification with our servicer. We kept the house — and our sanity.",
    n: "Monica R.",
    loc: "Atlanta, GA",
    situation: "Pre-Foreclosure",
  },
  {
    q: "I had no idea there was $38,400 in surplus funds sitting in court after my foreclosure. They found it, filed everything, and I had a check in 11 weeks.",
    n: "Darnell W.",
    loc: "Columbus, OH",
    situation: "Surplus Funds",
  },
  {
    q: "I inherited my mom's house and it needed $60k in repairs I couldn't afford. They got me a fair cash offer and closed in 18 days. No drama.",
    n: "Rebecca & James T.",
    loc: "Phoenix, AZ",
    situation: "Sell Fast",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="py-20 md:py-32 bg-white border-y border-[#E5E3DB]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="mb-4">
            <span className="gold-rule" />
            <span className="text-xs uppercase tracking-[0.24em] text-[#2C5545] font-medium">
              Real homeowners, real outcomes
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B1B3D] leading-tight">
            People who thought they'd lost everything — and didn't.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="rounded-lg border border-[#E5E3DB] p-8 bg-[#FAF9F6] flex flex-col"
            >
              <Quote className="h-6 w-6 text-[#C5A059] mb-4" />
              <blockquote className="font-display text-xl text-[#0B1B3D] leading-snug mb-6 flex-1">
                "{t.q}"
              </blockquote>
              <figcaption>
                <div className="font-medium text-[#0B1B3D]">{t.n}</div>
                <div className="text-xs text-[#64748B]">{t.loc}</div>
                <div className="inline-block mt-3 text-[10px] uppercase tracking-[0.2em] text-[#2C5545] border border-[#2C5545]/30 rounded-full px-2 py-1">
                  {t.situation}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
